import { userService } from '../services'
import { router } from '../helpers'


const user = JSON.parse(localStorage.getItem('user'))
const initialState = user
    ? { status: { loggedIn: true, }, user }
    : { status: {}, user: null }

export const authentication = {
    namespaced: true,
    state: initialState,


    actions: {
        login({ dispatch, commit }, { email, password }) {
            commit('LOGIN_REQUEST', { email })

            userService.login(email, password)
                .then(
                    user => {
                        commit('LOGIN_SUCCESS', user)
                        if(user.role==1){
                            router.push('/admin/dashboard')
                        }else if(user.role==4 || user.role==5){
                            router.push('/student/home')
                        }
                        else if(user.role==3){
                            //dispatch('mentor/getMentorData',{},{root:true})
                            router.push('/mentor/home')
                        }
                        else if(user.role==2){
                            router.push('/reviewer/home')
                        }
                        else{
                            router.push('/expert/home')
                        }
                    },
                    error => {
                        let errors=error.errors
                        commit('LOGIN_FAILURE', errors)
                    }
                )
        },
        isLoggedIn({commit, dispatch}){
            return new Promise((resolve, reject) => {
                userService.me()
                .then(
                user=>{commit('USER_AUTHENTICATED',user); resolve('valid')},
                error=>{
                    console.log(error)
                    console.log('expired token');
                    // router.push('/login')
                commit('LOGIN_FAILURE',error)
                reject(new Error('token invalid'))
                })
            })
             
        },
        
        logout({ commit }) {
            userService.logout()
            commit('LOGOUT')
        },
        verifyEmail({commit},data){
            return new Promise((resolve,reject) =>{
                userService.verifyEmail(data)
                .then(payload =>{
                    commit('EMAIL_VERIFIED', payload)
                    resolve(payload);
                },
                error =>{
                    commit('EMAIL_NOT_VERIFIED', error)
                    reject(error);
                }
                )
            });
        },
        getToken({ dispatch, commit }, { email, id }) {
            commit('LOGIN_REQUEST', { email })
    
            userService.getToken(email, id)
                .then(
                    user => {
                        commit('TOKEN_SUCCESS', user)
                    },
                    error => {
                        let errors=error.errors
                        commit('TOKEN_ERROR', errors)
                    }
                )
        },
    },
    
    mutations: {
        USER_AUTHENTICATED(state, user){
            state.status = {loggedIn: true}
            state.user = user
        },
        LOGIN_REQUEST(state, user) {
            state.status = { loggingIn: true }
            state.user = user
        },
        LOGIN_SUCCESS(state, user) {
            state.status = { loggedIn: true }
            state.user = user
        },
        LOGIN_FAILURE(state,errors) {
            state.status = {errors}
            state.user = null
        },
        LOGOUT(state) {
            state.status = {}
            state.user = null
        },
        EMAIL_VERIFIED(state, payload){
            console.log('payload: '+payload.email_verified_at )
            state.user.email_verified_at=payload.email_verified_at;
        },
        EMAIL_NOT_VERIFIED(state, error){
            state.all = {errors: error}
        },
        TOKEN_SUCCESS(state, user) {
            state.status = { loggedIn: true }
            state.user = user
        },
        TOKEN_ERROR(state,errors) {
            state.status = {errors}
            state.user = null
        },
    }
}
